// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kgJE","icon":"styles_icon__2gKZI"};